import { useIntl } from "react-intl";
import Button from "@rio-cloud/rio-uikit/Button";
import Dialog from "@rio-cloud/rio-uikit/Dialog";

export type ExportStage =
  | "maintenance"
  | "complementary"
  | "checkups"
  | "rioplans"
  | "writing"
  | "done"
  | "error";

interface IExportProgressDialogProps {
  show: boolean;
  stage: ExportStage;
  progress: number; // 0..100
  detail?: string;
  errorMessage?: string;
  onClose: () => void;
}

const STAGE_LABEL: Record<ExportStage, string> = {
  maintenance: "intl-msg:dealership.exportProgressDialog.stageMaintenance",
  complementary: "intl-msg:dealership.exportProgressDialog.stageComplementary",
  checkups: "intl-msg:dealership.exportProgressDialog.stageCheckups",
  rioplans: "intl-msg:dealership.exportProgressDialog.stageRioplans",
  writing: "intl-msg:dealership.exportProgressDialog.stageWriting",
  done: "intl-msg:dealership.exportProgressDialog.stageDone",
  error: "intl-msg:dealership.exportProgressDialog.stageError",
};

const ExportProgressDialog = ({
  show,
  stage,
  progress,
  detail,
  errorMessage,
  onClose,
}: IExportProgressDialogProps) => {
  const intl = useIntl();
  return (
    <Dialog
      show={show}
      bsSize="md"
      title={intl.formatMessage({ id: "intl-msg:dealership.exportProgressDialog.title" })}
      subtitle={intl.formatMessage({ id: "intl-msg:dealership.exportProgressDialog.subtitle" })}
      footer={
        <Button onClick={onClose} className="btn btn-primary" bsSize="lg">
          {intl.formatMessage({ id: "intl-msg:monitoring.checkup.closeButton" })}
        </Button>
      }
      body={
        <div className="w-full mx-auto bg-white dark:bg-neutral-900 rounded-lg p-6">
          {/* Texto da etapa atual */}
          <div className="text-size-16 text-color-darkest mb-3">
            {intl.formatMessage({ id: STAGE_LABEL[stage] })}
            {detail ? ` — ${detail}` : ""}
          </div>

          {/* Barra de progresso */}
          <div className="h-[10px] w-full rounded progress overflow-hidden mb-2">
            <div
              className="h-full progress-bar progress-bar-striped progress-bar-primary transition-all duration-200"
              style={{ width: `${Math.max(0, Math.min(100, progress))}%` }}
            />
          </div>

          {/* Percentual */}
          <div className="text-right text-size-16 text-color-darkest mb-2">
            {Math.round(progress)}%
          </div>

          {/* Mensagem de erro */}
          {stage === "error" && (
            <div className="text-color-danger text-size-14">
              {errorMessage || intl.formatMessage({ id: "intl-msg:dealership.exportProgressDialog.genericError" })}
            </div>
          )}
        </div>
      }
      onCloseValidation={() => {
        onClose();
        return true;
      }}
      showCloseButton
    />
  );
};

export default ExportProgressDialog;
